import actions from './actions';

const initState = {
    brands: [],
    models: [],
    years: []
};

export default function gocarReducer(state = initState, action) {
    switch (action.type) {
        case actions.DATA_BRANDS:
            const data = [...state.brands, ...action.data]
            return {...state, data}
        case actions.DATA_MODELS:
            return {...state, models: action.data}
        case actions.DATA_YEAR:
            return {...state, years: action.data}
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/gocar/reducer.js